import { render, staticRenderFns } from "./product-slider.vue?vue&type=template&id=282cd1bc&scoped=true"
import script from "./product-slider.vue?vue&type=script&lang=js"
export * from "./product-slider.vue?vue&type=script&lang=js"
import style0 from "./product-slider.vue?vue&type=style&index=0&id=282cd1bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282cd1bc",
  null
  
)

export default component.exports